export default __webpack_public_path__ + "static/media/DC.91870cb0.png";